import { Button, Form, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { getEditorInfo } from "src/common/attrEdit";
import { ZCopyByValueRule } from "src/common/attrEdit/ZCopyByValueRule";
import { edCompField } from "../EditorInfo2/ParamsEditorInfo2";
import { CopyByValueStore } from "./CopyByValueEditStore";
import {
  copyByValueFieldNames,
  CopyByValueForm,
} from "./CopyByValueForm/CopyByValueForm";

interface PropsCopyByValueEdit {
  store: CopyByValueStore;
  value?: ZCopyByValueRule;
  onChange?(newValue?: unknown): void;
}

export const CopyByValueEdit: React.FC<PropsCopyByValueEdit> = observer(
  ({ value, onChange, store }) => {
    const form = Form.useFormInstance();

    const onDelete = () => {
      onChange?.(undefined);
      store.setOpen(false);
    };
    const onCancel = () => {
      onChange?.(value);
      store.setOpen(false);
    };
    const onSubmit = (data: Record<string, unknown>) => {
      onChange?.(data);
      store.setOpen(false);

      /**
       * параметр multiple устанавливаем такой же,
       * как у атрибута-источника копирования
       */
      if (copyByValueFieldNames.parentAttributeId in data) {
        const parentAttributeId = data[copyByValueFieldNames.parentAttributeId];
        const linkAttributeId = data[copyByValueFieldNames.linkAttributeId];
        if (
          !parentAttributeId ||
          typeof parentAttributeId !== "string" ||
          !linkAttributeId ||
          typeof linkAttributeId !== "string"
        )
          return;

        const avaliableLinkAttrsMap = new Map(
          store.avaliableCopyAttrData.map((e) => [
            e.linkAttributeId,
            e.attributes,
          ]),
        );
        const copySrcAttributes = avaliableLinkAttrsMap.get(
          linkAttributeId || "",
        );
        const map = new Map(
          copySrcAttributes?.map((e) => [e.id, e.viewStyles]),
        );
        const attrViewStyles = map.get(parentAttributeId);
        const component = getEditorInfo(attrViewStyles)?.component;
        if (component && "multiple" in component) {
          const { multiple } = component;
          form?.setFieldValue(edCompField("multiple"), multiple);
        }
      }
    };

    return (
      <>
        <Button onClick={() => store.setOpen(true)}>
          {value?.parentAttributeId ? "Eсть" : "Нет"}
        </Button>
        {store.open && (
          <Modal
            open
            title="Копировать из атрибута связанного объекта"
            onCancel={() => store.setOpen(false)}
            footer={null}
          >
            <CopyByValueForm
              dataSrc={store}
              initialValues={value}
              onSubmit={onSubmit}
              onCancel={onCancel}
              onDelete={onDelete}
            />
          </Modal>
        )}
      </>
    );
  },
);
